export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const FORM_FIELD_UPDATED = 'FORM_FIELD_UPDATED';
